// # `TransparentPixel`
//
// This component is designed for the sole purpose of rendering an `<img />`
// tag with a transparent pixel. The source is a square, so we can set it's
// `height` and the `width` will automatically match.

import PropTypes from "prop-types";
import React, { Component } from "react";

import get from "lodash/get";
import isEqual from "lodash/isEqual";
import isUndefined from "lodash/isUndefined";
import reduce from "lodash/reduce";

export const transparentOneByOnePixelPNGBase64 =
  "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNgYAAAAAMAASsJTYQAAAAASUVORK5CYII=";

// Note: This cannot be purely rendered since it can accept a `style`
// property that is a mutable object. See `shouldComponentUpdate`.
export default class TransparentPixel extends Component {
  static propTypes = {
    // Accept a `string` or `number` for `height` because
    // `height="100%"` is a valid input but is not a number.
    height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    style: PropTypes.object,
  };

  // Do a deep comparison to determine if we need to update.
  shouldComponentUpdate(nextProps) {
    return !isEqual(nextProps, this.props);
  }

  // Take `this.props.style` and augment it with `pointerEvents: none`.
  // This is supposed to be invisible so it should never accept mouse
  // events. Note that this will not work on IE10, but hopefully we'll
  // still get by.
  get mergedPropsStyle() {
    return {
      ...get(this, "props.style"),
      height: this.props.height,
      pointerEvents: "none",
      zIndex: -1000,
    };
  }

  // Return an object that is a shallow clone of `this.props` with all
  // keys having a value of `undefined` or `null` removed. We don't just
  // check for falsy values because we need to allow something like
  // `height: 0`.
  get propsWithUndefinedAndNullRemoved() {
    return reduce(
      this.props,
      (memo, value, key) => {
        if (!isUndefined(value) && value !== null) {
          memo = {
            ...memo,
            [key]: value,
          };
        }

        return memo;
      },
      {},
      this,
    );
  }

  render() {
    return (
      <img
        {...this.propsWithUndefinedAndNullRemoved}
        alt=""
        src={transparentOneByOnePixelPNGBase64}
        style={this.mergedPropsStyle}
      />
    );
  }
}
